import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            sortable: true,
        },
        {
            prop: 'color',
            label: i18n.t('common_words.color'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'text_color',
            label: i18n.t('common_words.text_color'),
            sortable: true,
            show: false
        },
    ];
    
    return { tableColumns };
}
export default configTable;